import { fetchPost, fetchGet, fetchPut, fetchDelete } from '../services/Apiservice'
import {  categoryFormUploader } from './formuploader/category'

/**
 * Get category list from API
 */
export const categoryList = (data) => {
    return fetchGet('/categories', data)
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}

/**
 * Create new category from API
 */
export const categoryCreate = (data) => {
    const formData = categoryFormUploader(data);

    return fetchPost('/categories', formData)
    .then((res) => {
        return res
    })
    .catch((res) => {
        throw res
    })
}

/**
 * Edit category details from API
 */
export const categoryEdit = (id, data) => {
    console.log(data);
    const formData = categoryFormUploader(data)
    console.log(formData);
    return fetchPost(`/categories/${id}/update`, formData)
        .then(res => res)
        .catch(err => { throw err })
}

/**
 * Get category details from API
 */
export const categoryDetail = (id) => {
    return fetchGet(`/categories/${id}`)
        .then(res => res)
        .catch(err => { throw err })
}

/**
 * Delete category data through API
 */
export const categoryDelete = (id) => {
    return fetchDelete(`/categories/${id}`)
        .then(res => res)
        .catch(err => { throw err })
}


/**
 * Toggle category status through API
 */

export const categoryToggleStatus = (id) => {
    return fetchPost(`/categories/${id}/toggle-status`)
        .then(res => res)
        .catch(err => { throw err })
}